import { render } from "./PPCSettingsTabs.vue?vue&type=template&id=334b3d9a"
import script from "./PPCSettingsTabs.vue?vue&type=script&lang=js"
export * from "./PPCSettingsTabs.vue?vue&type=script&lang=js"

import "./PPCSettingsTabs.vue?vue&type=style&index=0&id=334b3d9a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__